<template>
	<div class="register-apply-page">
		<div class="main w1200" v-if="!pageStatus">
			<div class="back" @click="back">&lt;返回</div>
			<el-form class="form" :model="form" :rules="rule" ref="form">
				<div class="heading">企业实名注册 (企业证件注册)</div>
				<div class="yingyezhizhao">
					<el-form-item prop="businessLicense">
						<div class="label">
							<span class="c-FF0000">*</span>
							营业执照上传
						</div>
						<div class="yingyezhizhao-content">
							<el-upload
								class="yingyezhizhao-uploader"
								:action="uploadFileUrl"
								:show-file-list="false"
								:before-upload="uploadBusinessLicense.beforeUpload"
								:on-success="uploadBusinessLicense.onSuccess"
							>
								<img v-if="form.businessLicense" :src="form.businessLicense" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
							<div class="right-block">
								<div class="des">文件需清晰可见并在有效期内；请提供扫描原件，如为复印件请加盖公章</div>
								<div class="des">支持 JPG、JPEG、PNG格式，大小不超过 10MB</div>
								<div class="tip">*平台收集的资料信息会严格保密</div>
							</div>
						</div>
					</el-form-item>
				</div>
				<div class="form-list">
					<div class="form-item half">
						<el-form-item prop="companyName">
							<div class="label">
								<span class="c-FF0000">*</span>
								企业名称
							</div>
							<el-input clearable maxlength="80" v-model="form.companyName" placeholder="请输入企业名称"></el-input>
						</el-form-item>
					</div>
					<div class="form-item half">
						<el-form-item prop="orgNumber">
							<div class="label">
								<span class="c-FF0000">*</span>
								统一社会信用代码
							</div>
							<el-input clearable maxlength="18" v-model="form.orgNumber" placeholder="请输入18位社会信用代码"></el-input>
						</el-form-item>
					</div>
					<div class="form-item half">
						<el-form-item prop="person">
							<div class="label">
								<span class="c-FF0000">*</span>
								企业联系人
							</div>
							<el-input clearable maxlength="30" v-model="form.person" placeholder="请输入企业联系人姓名"></el-input>
						</el-form-item>
					</div>
					<div class="form-item half">
						<el-form-item prop="personMail">
							<div class="label">
								<span class="c-FF0000">*</span>
								联系人邮箱
							</div>
							<el-input clearable v-model="form.personMail" placeholder="例：ec_abc@163.com"></el-input>
						</el-form-item>
					</div>
					<div class="form-item half lianxirenshouji">
						<el-form-item prop="personMobile">
							<div class="label">
								<span class="c-FF0000">*</span>
								联系人手机
							</div>
							<el-input
								clearable
								type="text"
								maxlength="11"
								@keyup.native="form.personMobile = form.personMobile.replace(/[^\d]/g, '')"
								v-model="form.personMobile"
								placeholder="请输入联系人手机"
							>
								<el-select v-model="select" slot="prepend" placeholder="请选择">
									<el-option label="+86" :value="86"></el-option>
								</el-select>
							</el-input>
						</el-form-item>
					</div>
					<div class="form-item half verification-code" v-if="showResend">
						<div class="label">
							<span class="c-FF0000">*</span>
							验证码
						</div>
						<div class="code-box">
							<el-input clearable type="number" v-maxlength="6" v-model="form.verificationCode" placeholder="请输入验证码"></el-input>
							<el-button class="send-btn" type="primary" @click="sendCode">
								<CountDown ref="CountDown" :seconds="60"></CountDown>
							</el-button>
						</div>
					</div>
					<div class="form-item half" v-else></div>
					<div class="form-item half company-logo">
						<el-form-item prop="logoUrl">
							<div class="label">
								<span class="c-FF0000">*</span>
								企业LOGO
							</div>
							<el-upload
								class="company-logo-uploader"
								:action="uploadFileUrl"
								:show-file-list="false"
								:before-upload="uploadLogoUrl.beforeUpload"
								:on-success="uploadLogoUrl.onSuccess"
							>
								<img v-if="form.logoUrl" :src="form.logoUrl" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
							<div class="tip">请上传宽高比为 1:1 的 .jpg, .jpeg, .png 图片</div>
						</el-form-item>
					</div>
					<div class="form-item half">
						<el-form-item prop="officialWebsite">
							<div class="label">
								<!-- <span class="c-FF0000">*</span> -->
								企业官网
							</div>
							<el-input clearable v-model="form.officialWebsite" placeholder="例：http(s)://www.example.com"></el-input>
						</el-form-item>
					</div>
					<div class="form-item full">
						<el-form-item prop="address">
							<div class="label">企业地址</div>
							<el-input clearable type="textarea" :rows="2" maxlength="100" show-word-limit placeholder="请输入企业地址" v-model="form.address"></el-input>
						</el-form-item>
					</div>
					<div class="form-item full">
						<el-form-item prop="business">
							<div class="label">
								<span class="c-FF0000">*</span>
								企业主营业务简介
							</div>
							<el-input clearable type="textarea" :rows="2" maxlength="300" show-word-limit placeholder="请输入企业主营业务简介" v-model="form.business"></el-input>
						</el-form-item>
					</div>
					<div class="form-item full">
						<el-form-item prop="certifiedProducts">
							<div class="label">
								<span class="c-FF0000">*</span>
								拟申请碳足迹认证的产品
							</div>
							<el-input
								clearable
								type="textarea"
								:rows="2"
								maxlength="300"
								show-word-limit
								placeholder="请输入拟申请碳足迹认证的产品"
								v-model="form.certifiedProducts"
							></el-input>
						</el-form-item>
					</div>
				</div>
				<el-button class="submit-btn" type="primary" @click="handleSubmit">
					{{ $store.state.token ? '重新注册' : '提&nbsp;交' }}
				</el-button>
			</el-form>
		</div>
		<Foot></Foot>
		<!-- 提交成功 -->
		<Success v-if="pageStatus == 'success'"></Success>

		<!-- 拼图验证 -->
		<Vcode :show="isShow" @success="onSuccessPerson" @close="onClose" />
	</div>
</template>

<script>
	import Foot from '@/layout/Foot/Foot.vue';
import { SaveOrg, SaveOrgReg, FindOrg, InternationalAreaCode, SmsSend, ValidatePerson } from '@/common/api.js';
import Success from './components/Success.vue';
import CountDown from '@/components/CountDown/CountDown.vue';
// 拼图验证
import Vcode from 'vue-puzzle-vcode';
export default {
	components: {
		Foot,
		Success,
		CountDown,
		Vcode
	},
	data() {
		// 社会信用代码验证
		var validateOrgNumber = (rule, value, callback) => {
			const regex = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
			if (!regex.test(value)) {
				return callback(new Error('统一社会信用代码格式有误！'));
			}
			callback();
		};
		// 企业联系人邮箱验证
		var validatePersonMail = (rule, value, callback) => {
			const regex = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
			if (!regex.test(value)) {
				return callback(new Error('请输入正确邮箱地址'));
			}
			callback();
		};
		// 企业联系人手机号验证
		var validatePersonMobile = (rule, value, callback) => {
			const regex = /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/;
			if (!regex.test(value)) {
				return callback(new Error('请输入正确手机号码'));
			}
			callback();
		};
		// // 企业官网验证
		// var validateOfficialWebsite = (rule, value, callback) => {
		// 	const regex = new RegExp(
		// 		'^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
		// 		'i'
		// 	);
		// 	if (!regex.test(value)) {
		// 		return callback(new Error('官网格式不正确'));
		// 	}
		// 	callback();
		// };
		return {
			// 页面状态
			pageStatus: '',
			imageUrl: '',
			value: '',
			// 手机号区域
			select: 86,
			// 表单
			form: {
				companyName: '',
				orgNumber: '', // 社会统一信用代码
				// legalPerson: '',// 法人
				// legalPersonMobile: '', // 法人联系电话
				// email: '', //邮箱
				person: '', //联系人
				phoneAreaCode: '01',
				companyUserMobile: this.$store.state.regInfo.mobile || '', //联系方式
				personMobile: '', //联系方式
				personMail: '', //联系人邮箱
				businessLicense: '', // 营业执照
				establishTime: '', // 成立时间
				// orgType: '',//企业属性
				reAuthCompanyId: '',
				verificationCode: this.$store.state.regInfo.verificationCode || '', //验证码
				address: '', //企业地址
				business: '', // 主营业务
				electronicSeal: '', //电子签章
				logoUrl: '',
				officialWebsite: '', //企业官网
				certifiedProducts: '' //产品
			},

			// 表单验证
			rule: {
				businessLicense: [{ required: true, message: '请上传营业执照', trigger: 'blur' }],
				companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
				orgNumber: [{ required: true, message: '请输入18位社会信用代码', trigger: 'blur' }, { validator: validateOrgNumber }],
				person: [{ required: true, message: '请输入企业联系人姓名', trigger: 'blur' }],
				personMail: [{ required: true, message: '请输入企业联系人邮箱', trigger: 'blur' }, { validator: validatePersonMail }],
				personMobile: [{ required: true, message: '请输入企业联系人手机', trigger: 'blur' }, { validator: validatePersonMobile }],
				logoUrl: [{ required: true, message: '请上传企业LOGO', trigger: 'blur' }],
				// officialWebsite: [{ required: true, message: '请输入企业官网', trigger: 'blur' }, { validator: validateOfficialWebsite }],
				address: [{ required: true, message: '请输入企业地址', trigger: 'blur' }],
				business: [{ required: true, message: '请输入企业主营业务简介', trigger: 'blur' }],
				certifiedProducts: [{ required: true, message: '请输入拟申请碳足迹认证的产品', trigger: 'blur' }]
			},
			// 营业执照上传
			uploadBusinessLicense: {
				beforeUpload: (file) => {
					console.log('file: ', file);
					let valid = false;
					let extension = '';
					let types = ['jpg', 'jpeg', 'png'];
					let size = 10;
					if (file.name.lastIndexOf('.') > -1) {
						extension = file.name.slice(file.name.lastIndexOf('.') + 1);
					}
					valid = types.some((type) => {
						if (file.type.indexOf(type) > -1) return true;
						if (extension && extension.indexOf(type) > -1) return true;
						return false;
					});
					if (!valid) {
						this.$message.error(`文件格式不正确, 请上传${types.join('/')}格式文件!`);
						return false;
					}
					valid = file.size / 1024 / 1024 < size;
					if (!valid) {
						this.$message.error(`上传文件大小不能超过 ${size} MB!`);
						return false;
					}
				},
				onSuccess: (res, file) => {
					this.form.businessLicense = res.data.fileAddress;
					// this.imageUrl = URL.createObjectURL(file.raw);
				}
			},
			// 企业LOGO上传
			uploadLogoUrl: {
				beforeUpload: (file) => {
					console.log('file: ', file);
					let valid = false;
					let extension = '';
					let types = ['jpg', 'jpeg', 'png'];
					let size = 10;
					if (file.name.lastIndexOf('.') > -1) {
						extension = file.name.slice(file.name.lastIndexOf('.') + 1);
					}
					valid = types.some((type) => {
						if (file.type.indexOf(type) > -1) return true;
						if (extension && extension.indexOf(type) > -1) return true;
						return false;
					});
					if (!valid) {
						this.$message.error(`文件格式不正确, 请上传${types.join('/')}格式文件!`);
						return false;
					}
					valid = file.size / 1024 / 1024 < size;
					if (!valid) {
						this.$message.error(`上传文件大小不能超过 ${size} MB!`);
						return false;
					}
				},
				onSuccess: (res, file) => {
					this.form.logoUrl = res.data.fileAddress;
					// this.imageUrl = URL.createObjectURL(file.raw);
				}
			},
			//
			areaCode: [],
			//
			orgTypeList: [],
			//
			fileList: [],
			//
			fileList1: [],
			//
			fileList2: [],
			// 显示发送验证码
			showResend: false,
			// 是否显示拼图验证
			isShow: false
		};
	},
	created() {
		this.getMcode();
	},
	methods: {
		// 发送验证码
		sendCode() {
			let data = {
				mobile: this.form.companyUserMobile,
				smsType: 'register'
				// smsType: 'real'
			};
			SmsSend(data).then((res) => {
				if (res.success) {
					if (res.code === '163') {
						this.onShow();
					} else {
						this.$refs.CountDown.start();
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
		// 打开拼图验证
		onShow() {
			this.isShow = true;
		},
		// 关闭拼图验证
		onClose() {
			this.isShow = false;
		},
		// 拼图验证成功
		onSuccessPerson() {
			let data = {
				mobile: this.form.companyUserMobile
			};
			ValidatePerson(data).then((res) => {
				if (res.success) {
					this.onClose();
					this.sendCode();
				}
			});
		},
		//
		getMcode() {
			InternationalAreaCode({ setCode: ['ORG_AUTH_INTERNATIONAL_AREA_CODE', 'ORG_TYPE'] }).then((res) => {
				if (res.success) {
					this.areaCode.splice(0);
					this.areaCode.push(...res.data.ORG_AUTH_INTERNATIONAL_AREA_CODE);
					this.orgTypeList.push(...res.data.ORG_TYPE);
				}
				if (this.checkUser()) {
					this.getInfo();
					this.$store.commit('changeRegInfo');
				}
			});
		},
		//
		getInfo() {
			FindOrg().then((res) => {
				if (res.success) {
					this.form.companyName = res.data.companyName;
					this.form.orgNumber = res.data.orgNumber; // 社会统一信用代码
					this.form.person = res.data.person; //联系人
					this.form.phoneAreaCode = res.data.phoneAreaCode;
					this.form.personMobile = res.data.personMobile; //联系方式
					this.form.personMail = res.data.personMail; //联系人邮箱
					this.form.businessLicense = res.data.businessLicense; // 营业执照
					this.form.address = res.data.address; //企业地址
					this.form.business = res.data.business; // 主营业务
					this.form.logoUrl = res.data.logoUrl; //企业logo
					this.form.officialWebsite = res.data.officialWebsite; //企业官网
					this.form.certifiedProducts = res.data.certifiedProducts; //产品
					this.form.reAuthCompanyId = res.data.companyId; //id
					fileList.value = [{ url: res.data.businessLicense }];
					if (res.data.logoUrl) {
						fileList2.value = [{ url: res.data.logoUrl }];
					}
				}
			});
		},
		// 返回
		back() {
			this.$tip({
				content: '已录入的内容不会保存，是否退出？',
				confirm: () => {
					this.$router.back();
				}
			});
		},
		// 提交
		handleSubmit({ values, errors }) {
			this.$refs.form.validate((valid) => {
				if (valid) {
					if (!this.form.verificationCode && this.checkUser()) {
						this.toEdit();
					} else {
						this.toRegNew();
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 有token-编辑
		toEdit() {
			console.log('重新认证');
			SaveOrg(this.form).then((res) => {
				if (res.success) {
					this.pageStatus = 'success';
				} else {
					this.$message.error(res.message);
				}
			});
		},
		// 无token-注册
		toRegNew() {
			console.log('注册');
			SaveOrgReg(this.form).then((res) => {
				if (res.success) {
					this.pageStatus = 'success';
					this.$store.commit('changeToken', res.data.accesstoken);
					this.$store.commit('changeRegInfo');
				} else {
					if (res.code === '10011') {
						this.showResend = true;
						this.form.verificationCode = '';
					}
					this.$message.error(res.message);
				}
			});
		},
		handleAvatarSuccess(res, file) {
			console.log('res: ', res);
			console.log('file: ', file);
			this.imageUrl = URL.createObjectURL(file.raw);
			console.log('this.imageUrl: ', this.imageUrl);
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
			}
			return isJPG && isLt2M;
		}
	}
};
</script>

<style lang="scss" scoped>
.lianxirenshouji {
	::v-deep .el-select {
		.el-input {
			.el-input__inner {
				width: 88px;
			}
		}
	}
}
::v-deep {
	.el-form-item {
		.el-form-item__content {
			line-height: initial;
		}
	}
}
.register-apply-page {
	flex: 1;
	.main {
		display: flex;
		flex-direction: column;
		.back {
			align-self: flex-start;
			font-size: 16px;
			height: 68px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
		}
		.form {
			width: 830px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			.heading {
				margin: 40px 0;
				font-size: 22px;
				font-weight: 600;
				text-align: center;
			}
			.yingyezhizhao {
				width: 100%;
				display: flex;
				flex-direction: column;
				.label {
					font-size: 14px;
					margin-bottom: 8px;
				}
				.yingyezhizhao-content {
					display: flex;
					width: 100%;
					box-sizing: border-box;
					padding: 16px;
					background-color: #f2f3f5;
					::v-deep .yingyezhizhao-uploader {
						.el-upload {
							border: 1px dashed #d9d9d9;
							border-radius: 6px;
							cursor: pointer;
							position: relative;
							overflow: hidden;
							width: 132px;
							height: 88px;
							background-color: #ffffff;
							&:hover {
								border-color: #409eff;
							}
						}
						.avatar-uploader-icon {
							font-size: 28px;
							color: #8c939d;
							width: 132px;
							height: 88px;
							line-height: 88px;
							text-align: center;
						}
						.avatar {
							width: 132px;
							height: 88px;
							display: block;
						}
					}
					.right-block {
						margin-left: 24px;
						.des {
							font-size: 12px;
							line-height: 18px;
						}
						.tip {
							font-size: 12px;
							line-height: 18px;
							margin-top: 20px;
							color: #ff0000;
						}
					}
				}
			}
			// 列表
			.form-list {
				display: flex;
				flex-wrap: wrap;
				// width: 100%;
				margin-top: 20px;
				margin-left: -10px;
				margin-right: -10px;
				.form-item {
					display: flex;
					flex-direction: column;
					margin-bottom: 20px;
					box-sizing: border-box;
					padding: 0 10px;
					&.half {
						width: 50%;
					}
					&.full {
						width: 100%;
					}
					.label {
						font-size: 14px;
						margin-bottom: 8px;
					}
				}
				// 验证码
				.verification-code {
					.code-box {
						display: flex;
						.send-btn {
							margin-left: 15px;
							::v-deep {
								.countdown-component {
									&.disabled {
										color: #ffffff;
									}
								}
							}
						}
					}
				}
				// 企业LOGO
				.company-logo {
					display: flex;
					flex-direction: column;
					::v-deep .company-logo-uploader {
						.el-upload {
							border: 1px dashed #d9d9d9;
							border-radius: 6px;
							cursor: pointer;
							position: relative;
							overflow: hidden;
							width: 120px;
							height: 120px;
							background-color: #f2f3f5;
							&:hover {
								border-color: #409eff;
							}
						}
						.avatar-uploader-icon {
							font-size: 28px;
							color: #8c939d;
							width: 120px;
							height: 120px;
							line-height: 120px;
							text-align: center;
						}
						.avatar {
							width: 120px;
							height: 120px;
							display: block;
						}
					}
					.tip {
						margin-top: 4px;
						color: rgb(134, 144, 156);
						font-size: 12px;
					}
				}
			}
			// 提交按钮
			.submit-btn {
				align-self: center;
				margin: 44px auto;
			}
		}
	}
}
</style>
